import { ExternalLink } from 'lucide-react'

import { brokersMembers } from 'rails_routes'
import { Badge } from 'slab'
import { useWindowLocation } from 'utils/windowLocation'

export default function EnrollmentPaymentStatusPill ({
  memberId,
  paymentStatus,
  paidThroughMonthName,
  addLinkToTransactionsPage = false,
}: {
  memberId: string,
  paymentStatus: string,
  paidThroughMonthName: string | undefined,
  addPaymentStatusPrefix: boolean,
  addLinkToTransactionsPage?: boolean,
}) {
  const { assign } = useWindowLocation()

  const handleActionClick = addLinkToTransactionsPage
    ? () => {
        assign(brokersMembers.transactions({ member_id: memberId }))
      }
    : undefined
  return (
    <Badge
      actionIcon={addLinkToTransactionsPage ? ExternalLink : undefined}
      actionLabel={addLinkToTransactionsPage ? 'View transactions' : undefined}
      onActionClick={handleActionClick}
      type={getBadgeType(paymentStatus)}
    >
      {paymentStatus} {paidThroughMonthName && `(paid through ${paidThroughMonthName})`}
    </Badge>
  )
}

function getBadgeType (paymentStatus: string) {
  switch (paymentStatus) {
    case 'Payments OK':
      return 'success'
    default:
      return 'critical'
  }
}
